import { parseRgb, RGB } from "./parseRgb";

function getLuminance(rgb: RGB) {
  const [r, g, b] = rgb.map((v) => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return r * 0.2126 + g * 0.7152 + b * 0.0722;
}

function getContrast(foregroundColour: string, backgroundColour: string) {
  const foregroundRgb = parseRgb(foregroundColour);
  const backgroundRgb = parseRgb(backgroundColour);

  const foregroundLuminance = getLuminance(foregroundRgb);
  const backgroundLuminance = getLuminance(backgroundRgb);

  const contrastRatio =
    backgroundLuminance > foregroundLuminance
      ? (backgroundLuminance + 0.05) / (foregroundLuminance + 0.05)
      : (foregroundLuminance + 0.05) / (backgroundLuminance + 0.05);

  return parseFloat(contrastRatio.toFixed(2));
}

/**
 * Calculates a colour's WCAG (relative luminance) contrast ratio with white.
 * @param colour A hexadecimal colour code (string).
 *               Supports 3- and 6-character codes, but does *not* support
 *               codes with alpha values.
 * @returns A number between 1 and 21 representing the WCAG contrast ratio
 *          between colour and white. 1 is no contrast, 21 is maximum contrast.
 *          Return values are rounded to 2 decimal places.
 */
export function getContrastWithWhite(colour: string) {
  return getContrast(colour, "#FFF");
}
